import { useList, useDetail, useCreate, useUpdate, useDelete, fetchApi } from "@inmagik/react-crud"
import { RelazioneAtlante } from "../types"
import { API_URL } from "../constants"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"
import { useAuth } from "../auth"

export function useRelazioniAtlanteList(
  params: // accept also list of ids
  Record<string, string | number | Array<number>> = {},
  enabled = true
) {
  return useList<RelazioneAtlante>(`${API_URL}/admin/relazioni-atlante`, {
    query: params,
    reactQuery: {
      enabled: enabled,
      queryKey: ["relazioni-atlante", params],
    },
  })
}

export function useRelazioneAtlante(id: number | undefined) {
  return useDetail<RelazioneAtlante>(`${API_URL}/admin/relazioni-atlante`, id?.toString())
}

export function useRelazioneAtlanteLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/relazioni-atlante/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<RelazioneAtlante>
  }, [])
}

export function useRelazioniAtlanteLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/relazioni-atlante?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: RelazioneAtlante[] }>
  }, [])
}

export function useRelazioneAtlanteCreate() {
  return useCreate<RelazioneAtlante>(`${API_URL}/admin/relazioni-atlante`)
}

export function useRelazioneAtlanteUpdate() {
  return useUpdate<RelazioneAtlante>(`${API_URL}/admin/relazioni-atlante`)
}

export function useRelazioneAtlanteDelete() {
  return useDelete(`${API_URL}/admin/relazioni-atlante`)
}
